import React, { useState, useContext } from "react";
import Navbar from "../../../Shared/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Form, Row, Col, Alert } from "react-bootstrap";
import axios from 'axios';
import './AddSupplier.css';
import { ThemeContext } from "../../../Shared/Themes/ThemeContext";
import { baseURL } from '../../../Apiservices/Api';

const AddSupplier = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const { themeColor } = useContext(ThemeContext);

    const [formData, setFormData] = useState({
        supplierName: "",
        companyName: "",
        contactPerson: "",
        phone: "",
        email: "",
        address: "",
       
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        // Clear any previous errors when user types
        if (error) setError(null);
        if (success) setSuccess(false);
    };

    const handleSubmit = async (e, action = "save") => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);
        
        try {
            // Validate required fields
            if (!formData.supplierName || !formData.companyName || !formData.contactPerson) {
                throw new Error("Supplier Name, Company Name, and Contact Person are required fields");
            }

            // Make the POST request using axios
            const response = await axios.post(`${baseURL}/api/addsupplierlist`, formData);

            if (response.data.success) {
                setSuccess(true);
                // Reset form if the action is "save" (not saveAndClose)
                if (action === "save") {
                    setFormData({
                        supplierName: "",
                        companyName: "",
                        contactPerson: "",
                        phone: "",
                        email: "",
                        address: "",
                       
                    });
                }
                
                if (action === "saveAndClose") {
                    navigate('/admin-supplierlist');
                }
            } else {
                throw new Error(response.data.message || "Failed to save supplier");
            }
        } catch (error) {
            console.error("Error:", error);
            setError(error.message || "Failed to save supplier. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="suppliercontainer">
            <Navbar onToggleSidebar={setCollapsed} />
            <div className={`ViewSupplier ${collapsed ? "collapsed" : ""}`}>
                <div className="supplier-form-container">
                {success && (
                        <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
                            Supplier added successfully!
                        </Alert>
                    )}

                    {/* Error message */}
                    {error && (
                        <Alert variant="danger" onClose={() => setError(null)} dismissible>
                            {error}
                        </Alert>
                    )}
                    <h2 className="supplier-form-header" style={{ "--theme-color": themeColor }}>Add Supplier</h2>

                    {/* Success message */}
                  

                    <Form onSubmit={(e) => handleSubmit(e, "save")}>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Label>Supplier Name*</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Supplier Name"
                                    name="supplierName"
                                    value={formData.supplierName}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>

                            <Col md={6}>
                                <Form.Label>Company Name*</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Company Name"
                                    name="companyName"
                                    value={formData.companyName}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Label>Contact Person*</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Contact Person"
                                    name="contactPerson"
                                    value={formData.contactPerson}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>

                            <Col md={6}>
                                <Form.Label>Phone</Form.Label>
                                <Form.Control
                                    type="tel"
                                    placeholder="Enter Phone Number"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter Email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </Col>

                            <Col md={6}>
                                <Form.Label>Address</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Address"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Row>

                        <div className="addleads-form-footer">
                            <Button variant="secondary" onClick={() => navigate(-1)}>
                                Back
                            </Button>
                            <Button 
                                variant="primary" 
                                type="submit" 
                                disabled={loading}
                                style={{ backgroundColor: themeColor, borderColor: themeColor }}
                            >
                                {loading ? "Saving..." : "Save"}
                            </Button>
                            <Button
                                variant="success"
                                type="button"
                                disabled={loading}
                                onClick={(e) => handleSubmit(e, "saveAndClose")}
                            >
                                {loading ? "Saving..." : "Save & Close"}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default AddSupplier;